/**
 * 路由守卫 · 未登录重定向到 /login，登录了但角色不匹配回首页
 */
import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';

import { useAuth } from './AuthContext';
import type { StoredUser } from './storage';

type Role = StoredUser['role'];

interface Props {
  children: ReactNode;
  roles?: Role[];
}

export function RequireAuth({ children, roles }: Props) {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
